<template>

	<div>

		<div v-for="(catalogPageElement, index) in catalogPageElements" :key="catalogPageElement.id" class="pageElementBox">

			<span class="statusCircle" :class="catalogPageElement.status.name"></span>

			<ul>
				<li :class="catalogPageElement.contentElement.type.name">

					<!-- PRODUCT PLACEMENT -->
					<template v-if="[contentElementTypes.PRODUCT.id, contentElementTypes.HAUSAPOTHEKE.id, contentElementTypes.NEU_AM_MARKT.id].indexOf(catalogPageElement.contentElement.type.id) > -1 && catalogPageElement.contentElement.contentElementData[0]">

						<template v-if="catalogPageElement.contentElement.contentElementData[0].product">

							<span v-html="getDisplayName(catalogPageElement.contentElement.contentElementData[0].product)"></span>

							<!-- check if product has a voucher -->
							<template v-if="hasVoucher(catalogPageElement.contentElement.contentElementData[0].product)">
								<span class="hasVoucher">(mit GS)</span>
							</template>

						</template>

					</template>


					<!-- PRODUCT TIPP (advice) -->
					<template v-else-if="catalogPageElement.contentElement.type.id == contentElementTypes.ADVICE.id && catalogPageElement.contentElement.contentElementData[0]">

						<template v-if="catalogPageElement.contentElement.contentElementData[1].product != null">

						 	{{ catalogPageElement.contentElement.contentElementData[0].value }}: <span v-html="getDisplayName(catalogPageElement.contentElement.contentElementData[1].product)"></span>

							<!-- check if product tipp has a voucher -->
							<template v-if="hasVoucher(catalogPageElement.contentElement.contentElementData[1].product)">
								<span class="hasVoucher">(mit GS)</span>
							</template>

						</template>

					</template>

					<!-- RICH TEXT -->

					<template v-else-if="catalogPageElement.contentElement.type.id == contentElementTypes.RICH_TEXT.id">

						<template v-if="catalogPageElement.contentElement.contentElementData[0]">
							{{ catalogPageElement.contentElement.contentElementData[0].value }}
						</template>

						<!-- show product box if available -->
						<template v-if="catalogPageElement.contentElement.contentElementData[4] && catalogPageElement.contentElement.contentElementData[4].value != productBoxTypes.NONE.id">
							<br /><span class="productBox">Produkt-Box ({{ getProductBoxType(catalogPageElement.contentElement.contentElementData[4].value) }}): <span v-html="getDisplayName(catalogPageElement.contentElement.contentElementData[6].product)"></span></span>
						</template>

					</template>


					<!-- all OTHER elements -->
					<template v-else>

						<template v-if="catalogPageElement.contentElement.contentElementData[0]">
							{{ catalogPageElement.contentElement.contentElementData[0].value }}
						</template>

					</template>

				</li>
			</ul>

		</div>

	</div>

</template>




<script>

export default {

	props: ['catalogPageElements'],


	data() {
		return {

		}
	},

	created() {


	},

	mounted() {


	},

	updated() {


	},

	computed: {

		contentElementTypes() {
			return this.$store.getters.getTermsByTaxonomy('CONTENT_ELEMENT_TYPES');
		},

		productBoxTypes() {
            return this.$store.getters.getTermsByTaxonomy('PRODUCT_BOX_TYPES')
        },

    },

	methods: {

		getProductBoxType(typeId) {

			for(var key in this.productBoxTypes) {

				if(this.productBoxTypes[key].id == typeId) {

					switch(this.productBoxTypes[key].name) {
						case 'SMALL':
							return 'klein';
						case 'MEDIUM':
							return 'mittel';
						case 'LARGE':
							return 'groß';
					}

				}

			}

		},

		hasVoucher(product) {

			// check for "common" vouchers
			for(var i=0; i < product.productVariants.length; i++) {

				if(product.productVariants[i].voucher != null) {
					return true;
				}
			}

			// check if there are special vouchers
			if(product.productVouchers.length > 0) {
				return true;
			}

			return false;

		},

		getDisplayName(product) {

			if(product != null && product.displayName != null) {
				return product.displayName;
			} else {
				return "";
			}
			// console.log(product);

		}

	}

}
</script>

<style lang="scss" scoped>

    @import '../../assets/css/variables.scss';

	.statusCircle.CREATED {
		background: $statusCreated !important;
	}
	.statusCircle.APPROVED {
		background: $statusApproved !important;
	}
	.statusCircle.PRINT_APPROVED {
		background: $statusPrintApproved !important;
	}
	.statusCircle.REVIEW {
		background: $statusReview !important;
	}


	/* color sheme: pageElementTypes */
    li.RICH_TEXT {
    	background: $elementTypeRICHTEXT !important;
    }
		li.NEU_AM_MARKT,
		li.HAUSAPOTHEKE,
    li.PRODUCT {
    	background: $elementTypePRODUCT !important;
    }
    li.ADVICE {
        background: $elementTypeADVICE !important;
    }
    li.EXPERT_ADVICE {
        background: $elementTypeEXPERTADVICE !important;
    }
    li.APOPEDIA {
        background: $elementTypeAPOPEDIA !important;
    }
    li.RECIPE {
        background: $elementTypeRECIPE !important;
    }
    li.PUZZLE {
        background: $elementTypePUZZLE !important;
    }

</style>

<style scoped>
	.pageElementBox {
		position: relative;
		font-size: 0.8rem;
		z-index: 0;
	}
	.pageElementBox ul li {
		padding: 8px 10px;
		margin: 0 0 4px 0;
		position: relative;
		z-index: 0;
	}
	.hasVoucher {
		color: #888;
		font-style: italic;
	}
	.productBox {
		display: inline-block;
		font-size: 85%;
		padding: 2px 0;
	}
</style>
